export type ContractType =
  | 'FantasyTokenContract'
  | 'FantasyMiningContract'
  | 'FantasyToolNFTContract'
  | 'FantasyLandNFTContract'
  | 'FantasyGeneNFTContract'
  | 'FantasySlimeNFTContract'
  | 'FantasyGachaBoxNFTContract'
  | 'FantasyToolMaterialNFTContract'
  | 'FantasyToolMarketContract'
  | 'FantasyLandMarketContract'
  | 'FantasyGeneMarketContract'
  | 'FantasySlimeMarketContract'
  | 'FantasyGachaBoxMarketContract'
  | 'FantasyToolMaterialMarketContract';

export interface ISaleInfoFromMetaMask {
  isAvailableForSale: boolean;
  saleId?: string;
  amount?: string;
  tokenId?: number;
  price?: string;
  sellTime?: number;
}

export enum TokenFormat {
  ERC721 = 'ERC721',
  ERC1155 = 'ERC1155',
}
